import { FC, ElementType } from 'react';
import Link from 'next/link';
import cx from 'classnames';
import Tooltip from '../Tooltip/Tooltip';
import Typo from '../Typography';

type TCardSelect = {
  icon: JSX.Element;
  title: string;
  description: string;
  onClick?: () => void;
  as?: ElementType;
  href?: string;
  disabled?: boolean;
  territorySlug: string;
};

export const CardSelect: FC<TCardSelect> = ({
  icon,
  title,
  description,
  onClick,
  as: Component = 'button',
  href,
  disabled,
  territorySlug,
  ...rest
}) => {
  const isAnchor = Component === 'a';
  const anchorProps = isAnchor
    ? {
        href,
        target: '_blank',
        rel: 'noopener noreferrer',
      }
    : {};

  const card = (
    <Component
      onClick={onClick}
      className={cx(
        'h-auto flex-1 flex flex-col items-center justify-center p-5 pb-8 pt-5 rounded-lg border border-t2-neutral-grey03 hover:border-t2-primary-brandColor',
        {
          '!bg-t2-neutral-grey02 hover:!border-t2-neutral-grey03': disabled,
        },
      )}
      disabled={disabled}
      {...anchorProps}
      {...rest}
    >
      {icon}
      <span
        className={cx('mt-3 text-p2 font-semibold text-center', {
          '!text-t2-neutral-grey05': disabled,
        })}
      >
        {title}
      </span>
      <span
        className={cx('mt-5 p2-m text-center text-gray-600', {
          '!text-t2-neutral-grey05': disabled,
        })}
      >
        {description}
      </span>
    </Component>
  );

  return disabled ? (
    <Tooltip className="w-full" direction="bottom" trigger={card}>
      <Typo variant="small-p" className="!text-sm">
        Upgrade your membership role to write new posts and prompts in this Territory. See available membership roles{' '}
        <Link href={`/t/${territorySlug}/join/`} className="underline">
          here
        </Link>
        .
      </Typo>
    </Tooltip>
  ) : (
    card
  );
};
